import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';

const buildQuery = () => {
  return {
    query: gql`
      query getDatasetInfo($recordTimeStamp: DateTime) {
        getDatasetInfo(recordTimeStamp: $recordTimeStamp) {
          name
          latestRecordTimeStamp
        }
      }
    `,
    variables: {
      recordTimeStamp: '2020-01-01',
    },
  };
};

const getDatasetLastUpdatedAt = async (
  client: ApolloClient<NormalizedCacheObject>,
): Promise<{ name: string; latestRecordTimeStamp: string }[]> => {
  const query = buildQuery();
  const response = await client.query(query);
  return response.data.getDatasetInfo;
};

export default getDatasetLastUpdatedAt;
